import script from "./AnnotateMixin.vue?vue&type=script&lang=js"
export * from "./AnnotateMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__